import getCookie from '../getCookie';
const getUserCustomerGroup = () => {
    const userCookie = getCookie('userCookie');
    if (userCookie) {
        return JSON.parse(userCookie).customerGroup;
    }
    return null;
};
export default getUserCustomerGroup;
//# sourceMappingURL=getUserCustomerGroup.js.map